import { render, staticRenderFns } from "./DropoffShippop.vue?vue&type=template&id=718e036d&scoped=true&"
import script from "./DropoffShippop.vue?vue&type=script&lang=js&"
export * from "./DropoffShippop.vue?vue&type=script&lang=js&"
import style0 from "./DropoffShippop.vue?vue&type=style&index=0&id=718e036d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e036d",
  null
  
)

export default component.exports